import mapKeys from 'lodash/mapKeys';
import snakeCase from 'lodash/snakeCase';
import { SourceType } from './toBusinessModel';
import type {
    BusinessPersistenceDto,
    BusinessPersistenceModel,
    ImportSource,
} from '../../data-layer/business/types';

const getImportSource = (
    source: SourceType,
    model: BusinessPersistenceModel,
): ImportSource<SourceType> | undefined => ({
    source,
    url: model[source]?.url,
    import_format: model[source]?.importFormat,
});

export const toBusinessPersistenceDto = (
    model: BusinessPersistenceModel,
): BusinessPersistenceDto => {
    const sources: ImportSource<SourceType>[] = [
        getImportSource(SourceType.INSTAGRAM, model),
    ].filter(Boolean) as any;

    return {
        id: model.id,
        public_id: model.publicId,
        display_name: model.displayName,
        description: model.description,
        description_status: model.descriptionStatus,
        avatar_url: model.avatarUrl,
        cover_url: model.coverUrl,
        links: model.links ? mapKeys(model.links, (_, key) => snakeCase(key)) : model.links,
        created_at: model.createdAt,
        hide_in_feed: model.hideInFeed,
        offer_agreement: model.offerAgreement,
        import_settings: {
            sources,
        },
        display_categories: model.categories
            ? Object.values(model.categories).map((category) => ({
                  display_name: category.name,
                  id: category.id,
              }))
            : [],
        use_products_auto_import: model.useProductsAutoImport,
        disabled_offer_sources: model.useProductsDisableAutoParser ? [1] : [0],
        allowed_to_boosts: model.allowedToBoosts,
        geotargeting: model.geotargeting,
        is_service: model.isService,
        is_dikidi_approved: model.isDikidiApproved,
    };
};
